import BasePage from 'components/pages/BasePage/BasePage'
import HeroSection from './HeroSection'
import { useEffect } from 'react'
import './HomePage.scss'
import AssetFeed from 'components/feeds/AssetFeed/AssetFeed'
import { useCollections, useSearch, ZeroStateToShowEnum } from 'store'
import { useEnv } from '@praxis/component-runtime-env'

const HomePage = () => {
  const { getPaginatedCollectionAssets, featuredCollection, getFeatCollection } = useCollections()
  const { featuredCollectionId } = useEnv()
  const { resetAiKeywords } = useSearch()

  useEffect(() => {
    getFeatCollection()
    resetAiKeywords()
  }, [])

  return (
    <BasePage crumbs={{}}>
      <HeroSection />
      <div className="hc-pb-2x"></div>
      <AssetFeed
        pageName="homePage"
        isLoading={featuredCollection.collectionAssets.isLoading}
        assets={featuredCollection.collectionAssets.assets}
        totalCount={featuredCollection.collectionAssets.totalAssets}
        zeroStateToShow={ZeroStateToShowEnum.SEARCHPAGE}
        infiniteScrollMethod={getPaginatedCollectionAssets}
        collectionId={featuredCollectionId}
        isHomepage={true}
      />
    </BasePage>
  )
}

export default HomePage
